var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3675 6.161C3.27723 6.06499 3.1527 6.00851 3.02101 6.00382C2.88931 5.99914 2.76108 6.04664 2.66422 6.13599C2.56736 6.22534 2.50968 6.34932 2.50374 6.48097C2.4978 6.61262 2.54408 6.74129 2.6325 6.839L4.4385 8.7985C4.707 9.0615 5.107 9.0615 5.3555 8.8135L5.5375 8.634C6.19477 7.98761 6.85127 7.34044 7.507 6.6925L7.527 6.6725C8.13985 6.06853 8.74952 5.46136 9.356 4.851C9.44664 4.7561 9.49634 4.62937 9.49437 4.49815C9.4924 4.36693 9.43892 4.24175 9.34547 4.14961C9.25202 4.05747 9.1261 4.00577 8.99486 4.00565C8.86363 4.00554 8.73761 4.05703 8.644 4.149C8.04033 4.75617 7.43366 5.36034 6.824 5.9615L6.804 5.9815C6.17564 6.60265 5.54647 7.22298 4.9165 7.8425L3.3675 6.161Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export default ForwardRef;